"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "GridRow", {
  enumerable: true,
  get: function get() {
    return _GridRow.default;
  }
});
Object.defineProperty(exports, "GridCol", {
  enumerable: true,
  get: function get() {
    return _GridCol.default;
  }
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uiThemeable = _interopRequireDefault(require("@instructure/ui-themeable"));

var _uiPropTypes = require("@instructure/ui-prop-types");

var _capitalizeFirstLetter = _interopRequireDefault(require("@instructure/ui-utils/lib/capitalizeFirstLetter"));

var _safeCloneElement = _interopRequireDefault(require("@instructure/ui-utils/lib/react/safeCloneElement"));

var _matchComponentTypes = _interopRequireDefault(require("@instructure/ui-utils/lib/react/matchComponentTypes"));

var _passthroughProps = require("@instructure/ui-utils/lib/react/passthroughProps");

var _ScreenReaderContent = _interopRequireDefault(require("@instructure/ui-a11y/lib/components/ScreenReaderContent"));

var _GridRow = _interopRequireDefault(require("./GridRow"));

var _theme = _interopRequireDefault(require("./theme"));

var _GridCol = _interopRequireDefault(require("./GridCol"));

var _dec, _class, _class2, _temp;

var styles = {
  componentId: 'cMIPy',
  template: function template(theme) {
    return "\n\n.cMIPy_bGBk{display:block}\n\n.cMIPy_fFVr{outline:0.0625rem dashed red}\n\n.cMIPy_dTOw{box-sizing:border-box}\n\n@media screen and (--mediumMin){.cMIPy_crIs{box-sizing:border-box}}\n\n@media screen and (--largeMin){.cMIPy_cpbQ{box-sizing:border-box}}\n\n@media screen and (--xLargeMin){.cMIPy_dsuu{box-sizing:border-box}}";
  },
  'root': 'cMIPy_bGBk',
  'visualDebug': 'cMIPy_fFVr',
  'startAtSmall': 'cMIPy_dTOw',
  'startAtMedium': 'cMIPy_crIs',
  'startAtLarge': 'cMIPy_cpbQ',
  'startAtXLarge': 'cMIPy_dsuu'
};
var Grid = (
/**
---
category: components
---
**/
_dec = (0, _uiThemeable.default)(_theme.default, styles), _dec(_class = (_temp = _class2 =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Grid, _Component);

  function Grid() {
    (0, _classCallCheck2.default)(this, Grid);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Grid).apply(this, arguments));
  }

  (0, _createClass2.default)(Grid, [{
    key: "startAtClass",
    value: function startAtClass() {
      return !!this.props.startAt && "startAt".concat((0, _capitalizeFirstLetter.default)(this.props.startAt));
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this = this;

      var children = _react.Children.toArray(this.props.children);

      return children.map(function (child, index) {
        if ((0, _matchComponentTypes.default)(child, [_GridRow.default])) {
          return (0, _safeCloneElement.default)(child, (0, _objectSpread2.default)({}, (0, _passthroughProps.pickProps)(_this.props, Grid.propTypes), child.props, {
            /* child props should override parent */
            isLastRow: index + 1 === children.length
          }));
        } else {
          return child; // PropType validation should handle errors
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _classes;

      var classes = (_classes = {}, (0, _defineProperty2.default)(_classes, styles.root, true), (0, _defineProperty2.default)(_classes, styles[this.startAtClass()], !!this.props.startAt), (0, _defineProperty2.default)(_classes, styles.visualDebug, this.props.visualDebug), _classes);
      var props = (0, _passthroughProps.omitProps)(this.props, Grid.propTypes);
      return _react.default.createElement("span", Object.assign({}, props, {
        className: (0, _classnames.default)(classes)
      }), this.renderChildren());
    }
  }]);
  Grid.displayName = "Grid";
  return Grid;
}(_react.Component), _class2.propTypes = {
  children: _uiPropTypes.Children.oneOf([_GridRow.default, _ScreenReaderContent.default]),
  colSpacing: _propTypes.default.oneOf(['none', 'small', 'medium', 'large']),
  rowSpacing: _propTypes.default.oneOf(['none', 'small', 'medium', 'large']),
  hAlign: _propTypes.default.oneOf(['start', 'center', 'end', 'space-around', 'space-between']),
  vAlign: _propTypes.default.oneOf(['top', 'middle', 'bottom']),
  startAt: _propTypes.default.oneOf(['small', 'medium', 'large', 'x-large', null]),
  visualDebug: _propTypes.default.bool
}, _class2.defaultProps = {
  colSpacing: 'medium',
  rowSpacing: 'medium',
  hAlign: 'start',
  startAt: 'small',
  vAlign: 'top',
  visualDebug: false,
  children: null
}, _temp)) || _class);
exports.default = Grid;